import styled from 'styled-components';

const FormTitleText = styled<{ isActive: boolean }, 'h4'>('h4')`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 24px;
  height: 28px;

  color: ${props => (props.isActive ? '#00144D' : '#BDBDBD')};

  cursor: pointer;
`;

export default FormTitleText;



// WEBPACK FOOTER //
// ./src/components/FormComponents/FormTitleText.tsx